import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import MainLayout from '@/components/layouts/MainLayout.vue';
import ProfileIndexPage from '@/pages/profile/ProfileIndexPage.vue';

import ConnectedAccountSalesPage from '@/pages/connected-accounts/ConnectedAccountSalesPage.vue';
import ConnectedAccountMarketingPage from '@/pages/connected-accounts/ConnectedAccountMarketingPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/connected-accounts',
  component: MainLayout,
  beforeEnter: authGuard,
  meta: {
    requiresAuth: true,
    displayNav: true,
  },
  children: [
    {
      path: '',
      component: ProfileIndexPage,
      children: [
        {
          path: '',
          alias: '/pay-vendors/business-profile/connected-accounts',
          name: RouteNames.CONNECTED_ACCOUNTS.INDEX,
          component: ConnectedAccountSalesPage,
        },
        {
          path: 'marketing',
          alias: '/pay-vendors/business-profile/connect-marketing',
          name: RouteNames.CONNECTED_ACCOUNTS.MARKETING,
          component: ConnectedAccountMarketingPage,
        },
      ],
    },
  ],
});
